export default __webpack_public_path__ + "static/media/background-2x.470cf2bd.png";